'use strict';

import $ from 'jquery';

function scrambleEmail() {
  $('.js-emparse').each(function() {
    let email = $.trim($(this).html());
    email = email.replace('/', '@').split(';').reverse().join('');
    const emailLineBreakable = email.replace('@', '<wbr>@'); //if email is too long, it can be broken in to lines
    $(this).html(emailLineBreakable).attr('href', 'mailto:' + email).css('opacity', 1).addClass('font--bold font--link');
  });
}

function init(){
  $(document).ready( scrambleEmail );
}

export default { scrambleEmail, init };
export { scrambleEmail, init };
